import { FC, ReactNode } from 'react';
import hcLogo from '../../../../assets/images/logo/logo-green-xl.png';
import { HOMEPAGE_URL } from '../../../lib/constants';
import WordmarkLogo from '../../../svgs/WordmarkLogo';

interface LoginContainerProps {
  children: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  wordmarkLogoUrl?: string | null;
}

const LoginContainer: FC<LoginContainerProps> = ({
  children,
  title,
  description,
  wordmarkLogoUrl,
}) => {
  const showProviderWordmark = !!wordmarkLogoUrl;

  return (
    <div className="flex flex-col justify-start lg:min-h-screen lg:flex-row">
      <div className="flex h-[32px] flex-1 flex-wrap items-center justify-center gap-x-5 pt-screen-5 lg:absolute lg:top-7 lg:left-10 lg:p-0">
        <div>
          <a href={HOMEPAGE_URL} rel="noreferrer" target="_blank">
            {showProviderWordmark ? (
              <img
                src={wordmarkLogoUrl}
                className="h-[32px] w-auto max-w-[200px] object-contain object-left"
                alt="logo"
              />
            ) : (
              <>
                <WordmarkLogo className="hidden h-[32px] lg:flex" />
                <img
                  src={hcLogo}
                  className="flex h-[32px] w-[32px] lg:hidden"
                  alt="logo"
                />
              </>
            )}
          </a>
        </div>
      </div>
      <div className="flex flex-1 flex-col items-center justify-center pb-screen-5 pt-screen-5 text-green-150">
        {title && (
          <div className="mb-3 mt-3 max-w-[488px] px-4 text-center font-serif text-subtitle-small font-light md:mb-2 md:text-subtitle">
            {title}
          </div>
        )}
        {description && (
          <div className="mb-8 max-w-[488px] px-4 text-center text-caption">
            {description}
          </div>
        )}

        <div className="w-3/4 max-w-[488px]">{children}</div>
      </div>
      <div className="w-full lg:w-[560px]">
        <div className="flex h-full w-full shrink flex-col items-center justify-center bg-cover p-8 lg:m-0 lg:bg-[url('assets/images/signup/side-bg.png')]" />
      </div>
    </div>
  );
};

export default LoginContainer;
